import React from 'react';

import {
  Typography,
} from '@material-ui/core';


const services = () => {
  document.title = 'Services';
  return (
    <React.Fragment>
      <Typography variant="subheading">
        The matrimony committee &amp; their team Members will provide match making services for Lohana Community candidates seeking suitable life partner. They will be giving opportunity to such individual candidates &amp; their Families to Register in Website <a href="https://lmplagnasetu.com">www.lmplagnasetu.com</a> Free of charge and meet their suitable like minded educated candidates with similar age group and family details.
        <br /><br />
        <b>Personalized Match Making Services: Every Sunday.</b> <br />
        These matrimonial services will be organised with objectives to provide ultimate partner search experience and serve the community by connecting most suitable like minded Brides &amp; Grooms and set happiness in society.
        <br /><br />
        <b>Match Making Swayamvars:</b><br />
        We periodically will organize get - to - gathers of various age group of educated /professional candidates (boys  Girls) and give them opportunity to meet, interact , understand and interview prospective other participants in search of suitable life partner.
        <br /><br />
        <b>Online Web Portal:</b><br />
        By this portal we have created a revolutionary easy to operate website which is user friendly, easy to search required partner preference, send interest express notification to favored suitable candidate, Shortlist preferred candidates and also to contact parents of such candidates for matrimonial purpose . with this online match making facilities serve single objective to provide ultimate partner search experience and serve the community by connecting most suitable likeminded Brides &amp; Grooms get them married within the community
        <br /><br />
      </Typography>
    </React.Fragment>
  );
};


export default services;



// WEBPACK FOOTER //
// ./src/main/components/Services.js